module.exports = __webpack_public_path__ + "zvetseni-prsou_62_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_62_after.jpg
// module id = 1357
// module chunks = 0